module.exports = __webpack_public_path__ + "static/media/GutHowItWorks2.7b9a0e79.png";